<template>
  <div class="kidmenu">

         <v-list-tile  key="id" @click="gotoKid()">
           <v-list-tile-action><v-icon></v-icon></v-list-tile-action>
           <v-list-tile-title>{{name}}</v-list-tile-title>
         </v-list-tile>

</div>

</template>

<script>
// import firebase from 'firebase/app'
import {mapState} from 'vuex'

export default {
  name: 'KidMenu2',
  components: {
  },
  props: {
    'kid': { // id and name object
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name
    })
  },
  data () {
    return {
      categories: null,
      dashboard: 'I',
      toggleMenu: true,
      settingsItems: [
        {title: 'Account', icon: 'account_box', to: '/parents/kidaccount/'},
        {title: 'Site', icon: 'account_box', to: '/parents/kidsite/'},
        {title: 'Seller', icon: 'account_box', to: '/parents/kidseller/'},
        {title: 'Correspondence', icon: 'account_box', to: '/parents/kidcorrespondence/'}
      ]
    }
  },
  methods: {

    gotoKid: function () {
      this.$router.push({path: '/parents/kid/'})
      this.$store.commit('parent/setKidSelected', this.kid)
    },

    gotoProfile: function () {
      this.$router.push({path: '/parents/profile/'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.kidmenu {
  margin-left: 13px;
}
</style>
